import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

type IProps = {
    steps: number
    unity?: string
    maxValue: number
}

const Steps = ({ steps, unity, maxValue }: IProps): JSX.Element => {
    const [points, setPoints] = useState<any[]>([])

    const createpoints = (steps = 0, maxValue = 0): number[] => {
        const points: number[] = []
        points.push(0)

        if (steps < 1) return points

        const division = maxValue / steps
        let accumulate = 0

        for (let i = 1; i < steps; i++) {
            accumulate += division
            points.push(accumulate)
        }

        points.push(maxValue)

        return points
    }

    useEffect(() => {
        const pointsAux = createpoints(steps, maxValue)
        setPoints(pointsAux)
    }, [steps, maxValue])

    return (
        <StyledSteps data-testid="test-wrapper-steps">
            {points.map((point, index) => {
                return (
                    <li data-testid={'step-' + index} key={index} className="item">
                        {point.toFixed(1)}
                        {unity}
                    </li>
                )
            })}
        </StyledSteps>
    )
}

export default Steps

const StyledSteps = styled.ul`
    display: flex;
    height: 11px;
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
    font-size: 13px;
    color: #868695;
    padding: 0px 16px;

    .item {
        flex: 1;
    }

    .item:last-of-type {
        flex: 0;
        white-space: nowrap;
        position: relative;
    }

    li {
        &:first-of-type {
            border-radius: 4px 0px 0px 4px;
        }

        &:last-of-type {
            border-radius: 0px 4px 4px 0;
            margin-right: 0;
        }
    }
`
